import styled from "@emotion/styled"

export const StyledTitleSection = styled.section`
  position: relative;
  padding: 100px 0;
  text-align: center;
  background-color: #414141;

  @media (min-width: 768px) {
    padding: 120px 0;
  }

  @media (min-width: 1200px) {
    padding: 160px 0;
  }

  @media (min-width: 1600px) {
    padding: 200px 0;
  }

  .title-section-bg {
    display: block;
    position: absolute !important;
    z-index: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: .2 !important;
  }

  .container {
    position: relative;
    z-index: 1;
  }

  h1 {
    margin: 0 auto;
    text-transform: uppercase;

    @media (max-width: 575px) {
      font-size: 2.125rem;
    }

    @media (min-width: 576px) {
      font-size: 2.3rem;
    }

    @media (min-width: 768px) {
      font-size: 2.8125rem;
    }

    @media (min-width: 992px) {
      font-size: 3.5rem;
    }

    @media (min-width: 1440px) {
      font-size: 4rem;
    }
  }

  p {
    margin: 1.25rem auto 0;
    max-width: 430px;
    color: rgba(255, 255, 255, 0.75);

    @media (max-width: 575px) {
      font-size: .875rem;
    }

    @media (min-width: 768px) {
      margin: 1.75rem auto 0;
    }

    @media (min-width: 992px) {
      margin: 2rem auto 0;
    }
  }
`
